import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Dropdown, UIKits } from "../../../Constants/Constants";
import BasicDropdown from "./BasicDropdown";
import RoundedDropdown from "./RoundedDropdown";
import SplitDropdown from "./SplitDropdown";
import HeadingDropdown from "./HeadingDropdown";
import DropdownWithInput from "./DropdownWithInput";
import DarkDropdown from "./DarkDropdown";
import UniqueDropdown from "./UniqueDropdown/UniqueDropdown";
import JustifyContent from "./JustifyContent";
import Alignments from "./Alignments";
import HelperCard from "./HelperCard/HelperCard";
import DividerDropdown from "./DividerDropdown/DividerDropdown";
import DropdownSizing from "./DropdownSizing/DropdownSizing";
import { Fragment } from "react/jsx-runtime";
import DropdownOptions from "./DropdownOptions/DropdownOptions";

const DropdownContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Dropdown} parent={UIKits} />
      <Container fluid className="dropdown-page">
        <Row>
          <BasicDropdown />
          <RoundedDropdown />
          <SplitDropdown />
          <HeadingDropdown />
          <DropdownWithInput />
          <DarkDropdown />
          <UniqueDropdown />
          <JustifyContent />
          <Alignments />
          <HelperCard />
          <DividerDropdown />
          <DropdownSizing />
          <DropdownOptions />
        </Row>
      </Container>
    </Fragment>
  );
};
export default DropdownContainer;
